import(/* webpackMode: "eager" */ "/app/components/ProjectResultCards.js")